"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeColorIndexCalculator = void 0;
var map_creator_1 = require("../../../../base-utils/map-creator");
var enums_1 = require("../../../model/color/enums");
var enums_2 = require("../../../model/themes/enums");
var theme_drawing_color_collection_1 = require("../../../model/themes/theme-drawing-color-collection");
var ThemeColorIndexCalculator = (function () {
    function ThemeColorIndexCalculator() {
    }
    ThemeColorIndexCalculator.calculateThemeColorIndex = function (themeValue) {
        var schemeValue = ThemeColorIndexCalculator.richEditThemeColorValuesToSchemeColorValuesTranslationTable[themeValue];
        var themeColorIndex = theme_drawing_color_collection_1.ThemeDrawingColorCollection.schemeColorValuesToThemeColorIndexTranslationTable[schemeValue];
        if (schemeValue !== undefined && themeColorIndex !== undefined)
            return themeColorIndex;
        var themeColorIndexVariantB = ThemeColorIndexCalculator.richEditThemeColorValuesToThemeColorIndexTranslationTable[themeValue];
        return themeColorIndexVariantB !== undefined ? themeColorIndexVariantB : enums_1.ThemeColorIndexConstants.None;
    };
    ThemeColorIndexCalculator.richEditThemeColorValuesToSchemeColorValuesTranslationTable = new map_creator_1.MapCreator()
        .add(enums_1.ThemeColorValues.Accent1, enums_2.SchemeColorValues.Accent1)
        .add(enums_1.ThemeColorValues.Accent2, enums_2.SchemeColorValues.Accent2)
        .add(enums_1.ThemeColorValues.Accent3, enums_2.SchemeColorValues.Accent3)
        .add(enums_1.ThemeColorValues.Accent4, enums_2.SchemeColorValues.Accent4)
        .add(enums_1.ThemeColorValues.Accent5, enums_2.SchemeColorValues.Accent5)
        .add(enums_1.ThemeColorValues.Accent6, enums_2.SchemeColorValues.Accent6)
        .add(enums_1.ThemeColorValues.Background1, enums_2.SchemeColorValues.Background1)
        .add(enums_1.ThemeColorValues.Background2, enums_2.SchemeColorValues.Background2)
        .add(enums_1.ThemeColorValues.Dark1, enums_2.SchemeColorValues.Text1)
        .add(enums_1.ThemeColorValues.Dark2, enums_2.SchemeColorValues.Text2)
        .add(enums_1.ThemeColorValues.FollowedHyperlink, enums_2.SchemeColorValues.FollowedHyperlink)
        .add(enums_1.ThemeColorValues.Hyperlink, enums_2.SchemeColorValues.Hyperlink)
        .add(enums_1.ThemeColorValues.Light1, enums_2.SchemeColorValues.Background1)
        .add(enums_1.ThemeColorValues.Light2, enums_2.SchemeColorValues.Background2)
        .add(enums_1.ThemeColorValues.Text1, enums_2.SchemeColorValues.Text1)
        .add(enums_1.ThemeColorValues.Text2, enums_2.SchemeColorValues.Text2)
        .get();
    ThemeColorIndexCalculator.richEditThemeColorValuesToThemeColorIndexTranslationTable = new map_creator_1.MapCreator()
        .add(enums_1.ThemeColorValues.Accent1, enums_1.ThemeColorIndexConstants.Accent1)
        .add(enums_1.ThemeColorValues.Accent2, enums_1.ThemeColorIndexConstants.Accent2)
        .add(enums_1.ThemeColorValues.Accent3, enums_1.ThemeColorIndexConstants.Accent3)
        .add(enums_1.ThemeColorValues.Accent4, enums_1.ThemeColorIndexConstants.Accent4)
        .add(enums_1.ThemeColorValues.Accent5, enums_1.ThemeColorIndexConstants.Accent5)
        .add(enums_1.ThemeColorValues.Accent6, enums_1.ThemeColorIndexConstants.Accent6)
        .add(enums_1.ThemeColorValues.Background1, enums_1.ThemeColorIndexConstants.Light1)
        .add(enums_1.ThemeColorValues.Background2, enums_1.ThemeColorIndexConstants.Light2)
        .add(enums_1.ThemeColorValues.Dark1, enums_1.ThemeColorIndexConstants.Dark1)
        .add(enums_1.ThemeColorValues.Dark2, enums_1.ThemeColorIndexConstants.Dark2)
        .add(enums_1.ThemeColorValues.FollowedHyperlink, enums_1.ThemeColorIndexConstants.FollowedHyperlink)
        .add(enums_1.ThemeColorValues.Hyperlink, enums_1.ThemeColorIndexConstants.Hyperlink)
        .add(enums_1.ThemeColorValues.Light1, enums_1.ThemeColorIndexConstants.Light1)
        .add(enums_1.ThemeColorValues.Light2, enums_1.ThemeColorIndexConstants.Light2)
        .add(enums_1.ThemeColorValues.Text1, enums_1.ThemeColorIndexConstants.Dark1)
        .add(enums_1.ThemeColorValues.Text2, enums_1.ThemeColorIndexConstants.Dark2)
        .add(enums_1.ThemeColorValues.None, enums_1.ThemeColorIndexConstants.None)
        .get();
    return ThemeColorIndexCalculator;
}());
exports.ThemeColorIndexCalculator = ThemeColorIndexCalculator;
